export default "__VITE_ASSET__0jbuPUhW__"